import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import axios from 'libs/fetch'
import { queryKeys } from 'config/queryKeys'

export const useConfirmProductMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: confirmProductMutation, isPending: isConfirmProductMutationLoading } =
		useMutation({
			mutationFn: (id: string) => {
				return axiosPrivate.post(apiRoutes.productConfirm(id))
			},
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
				useToast({
					type: 'success',
					message: t('Product confirmed')
				})()
			},
			onError: (error) => {
				if (axios.isAxiosError(error)) {
					for (const [_key, value] of Object.entries(error?.response?.data)) {
						useToast({
							type: 'error',
							message: t(value as string)
						})()
					}

					return
				}
				useToast({
					type: 'error',
					message: t('Something went wrong')
				})()
			}
		})

	const { mutate: unconfirmProductMutation, isPending: isUnconfirmProductMutationLoading } =
		useMutation({
			mutationFn: (id: string) => {
				return axiosPrivate.post(apiRoutes.productUnconfirm(id))
			},
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
				useToast({
					type: 'success',
					message: t('Product unconfirmed')
				})()
			},
			onError: (error) => {
				if (axios.isAxiosError(error)) {
					for (const [_key, value] of Object.entries(error?.response?.data)) {
						useToast({
							type: 'error',
							message: t(value as string)
						})()
					}

					return
				}
				useToast({
					type: 'error',
					message: t('Something went wrong')
				})()
			}
		})

	return {
		confirmProductMutation,
		unconfirmProductMutation,
		isConfirmProductMutationLoading,
		isUnconfirmProductMutationLoading
	}
}
